import React, { useState, useEffect } from "react";
import styled from "styled-components"
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import logo from "./images/fullLogo.png";
import { jwtDecode } from "jwt-decode";
import WarningBanner from './WarningBanner';

const Header = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [firstName, setFirstName] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 1425);
  
  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 1425);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const token = localStorage.getItem("token");
    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
  
    if (token) {
      const decoded = jwtDecode(token);
      const { userId, role } = decoded;
      setUserRole(role);

      fetch(`${API_URL}account/${userId}`)
        .then((res) => res.json())
        .then((data) => {
          setFirstName(data.firstName);
          if (data.role === "coach" || data.role === "admin") {
            localStorage.setItem("coachLN", data.lastName);
          }
        })
        .catch((error) => console.error("Error fetching account details:", error));
    }
  }, []);
useEffect(() => {
  const savedLanguage = localStorage.getItem("language");
  if (savedLanguage) {
    i18n.changeLanguage(savedLanguage);
  }
}, [i18n]);
const handleLogoClick = () => {
  navigate("/");
};
const handleLoginClick = () => {
  navigate("/login");
};
const handleSignupClick = () => {
  navigate("/signup");
};
const handleLogout = () => {
  localStorage.removeItem("token");
  sessionStorage.clear()
  setFirstName(null);
  setUserRole(null);
  navigate("/");
};
const switchLanguage = (lang) => {
  i18n.changeLanguage(lang);
  localStorage.setItem("language", lang);
};

return (
  <>
    <Headerbody>
          <Title onClick={handleLogoClick}><img src={logo} alt="IP Logo"/></Title>
      <NavMenu>
        <NavItem onClick={() => navigate("/about")}>{t('header.about')}</NavItem>
        <NavItem onClick={() => navigate("/coach")}>{t('header.coach')}</NavItem>
        <NavItem onClick={() => navigate("/contact")}>{t('header.contact')}</NavItem>
        <NavItem onClick={() => navigate("/success")}>{t('header.success')}</NavItem>
        <NavItem onClick={() => navigate("/consultation")}>{t('header.consult')}</NavItem>
        <NavItem onClick={() => navigate("/shop")}>{t('header.shop')}</NavItem>
      </NavMenu>
      {firstName ? (
        <UserGreeting>{t('header.greeting')}, {firstName}</UserGreeting>
      ) : (
        <p> </p>
      )}
      <LanguageSwitcher>
        <span>
          <button onClick={() => switchLanguage('fr')}>FR</button>/ 
          <button onClick={() => switchLanguage('en')}>EN</button>
        </span>
      </LanguageSwitcher>
      <MenuContainer>
        <MenuButton onClick={() => setIsOpen(!isOpen)}>☰</MenuButton>
        {isOpen && (
          <DropdownMenu>
            {isLargeScreen ? (
              <>
                  {(userRole === "admin" || userRole === "coach") && (
                    <DropdownItem onClick={() => navigate("/coach-dashboard")}>
                        {t("header.dashboard")}
                    </DropdownItem>
                )}
                {firstName ? (
                    <div>
                      <DropdownItem onClick={() => navigate("/profile")}>Profile</DropdownItem>
                      <DropdownItem onClick={handleLogout}>{t("header.signout")}</DropdownItem>
                    </div>
                ) : (
                  <>
                    <DropdownItem onClick={handleLoginClick}>{t("header.login")}</DropdownItem>
                    <DropdownItem onClick={handleSignupClick}>{t("header.signup")}</DropdownItem>
                  </>
                )}
              </>
            ) : (
              <>
                <DropdownItem onClick={() => navigate("/about")}>{t('header.about')}</DropdownItem>
                <DropdownItem onClick={() => navigate("/coach")}>{t('header.coach')}</DropdownItem>
                <DropdownItem onClick={() => navigate("/contact")}>{t("header.contact")}</DropdownItem>
                <DropdownItem onClick={() => navigate("/success")}>{t('header.success')}</DropdownItem>
                <DropdownItem onClick={() => navigate("/consultation")}>{t("header.consult")}</DropdownItem>
                <DropdownItem onClick={() => navigate("/shop")}>{t('header.shop')}</DropdownItem>
                 {(userRole === "admin" || userRole === "coach") && (
                    <DropdownItem onClick={() => navigate("/coach-dashboard")}>
                        {t("header.dashboard")}
                    </DropdownItem>
                )}
                {firstName ? (
                  <div>
                    <DropdownItem onClick={() => navigate("/profile")}>Profile</DropdownItem>
                    <DropdownItem onClick={handleLogout}>{t("header.signout")}</DropdownItem>
                  </div>
                ) : (
                  <>
                    <DropdownItem onClick={handleLoginClick}>{t("header.login")}</DropdownItem>
                    <DropdownItem onClick={handleSignupClick}>{t("header.signup")}</DropdownItem>
                  </>
                )}
              </>
            )}
          </DropdownMenu>
        )}
      </MenuContainer>
    </Headerbody>
    <WarningBanner />
    </>
  );
}

export default Header;

const Title = styled.span`
cursor: pointer;
`

const Headerbody = styled.div`
  background-color: white;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  height: 100px;
  border-bottom: 3px solid green;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  position: relative;
  `;

const LanguageSwitcher = styled.div`
    position: absolute;
  right: 0;
  top: 40px;
  background-color: white;
  color: black;
  width: 130px;
  
  button {
    font-size: 15px;
    border:none;
    padding: 5px 5px;
    cursor: pointer;
    background-color: transparent;
    border-radius: 30px;
    &:hover {
      background-color: #f0f0f0;
    }
  }
`;
const NavMenu = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  position: absolute;
  left: 250px;
  margin-left:50px;
  margin-right: 50px;
  @media (max-width: 1425px) {
    display: none;
  }
`;

const NavItem = styled.div`
  padding: 20px 15px;
  cursor: pointer;
  font-weight: 500;
  font-size: 15px;
  position: relative;
  display: flex;
  text-align: center;
  width: 105px;
  align-items: center;
  height: 100%;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: rgba(148,163,135,1);
    color: white;
  }

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 20%;
    bottom: 20%;
    width: 1px;
    background-color: #ccc;
  }

  &:first-child::before {
    content: none;
  }
`;
const MenuContainer = styled.div`
  display: block;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
`;
const MenuButton = styled.button`
  background: none;
  border: none;
  color: black;
  font-size: 30px;
  cursor: pointer;
  z-index: 100;
`;
const DropdownMenu = styled.div`
  position: absolute;
  right: 0;
  top: 40px;
  background-color: white;
  color: black;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 200px;
  z-index: 10;
`;

const DropdownItem = styled.div`
padding: 10px 15px;
  background-color: white;
  border-bottom: 1px solid #ddd;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background-color 0.3s;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: rgba(148,163,135,1);
    color: white;
  }
`;
const UserGreeting = styled.p`
  margin-right: 120px;
  font-weight: bold;
  color: green;
  @media (max-width: 600px) {
    display: none;
  }
`;
